import { render, staticRenderFns } from "./TypingDots.vue?vue&type=template&id=06e7cd0c&scoped=true&lang=pug&"
import script from "./TypingDots.vue?vue&type=script&lang=js&"
export * from "./TypingDots.vue?vue&type=script&lang=js&"
import style0 from "./TypingDots.vue?vue&type=style&index=0&id=06e7cd0c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7cd0c",
  null
  
)

export default component.exports